import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@vapor/react-material";
import React, { useState } from "react";
import { MicroCategory } from "../../newDocuments/types";
import { useDocumentList } from "../state/useDocumentList";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 2;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

interface SelectMultipleCheckboxesProps {
  options: MicroCategory[];
  handleCheckboxChange: (category: MicroCategory) => boolean | void;
}
const SelectMultipleCheckboxes: React.FC<SelectMultipleCheckboxesProps> = ({
  options,
  handleCheckboxChange,
}: SelectMultipleCheckboxesProps) => {
  const { setIsFiltering } = useDocumentList();
  return (
    <div>
      <FormControl sx={{ width: "auto" }}>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={Object.keys(options).length > 0 ? ["Options"] : []}
          placeholder="Tipo documento"
          input={<OutlinedInput />}
          MenuProps={MenuProps}
          renderValue={() => "Tutte le tipologie"}
        >
          {options.length > 0 ? (
            options.map(({ name, checked, docCount }) => (
              <MenuItem sx={{ p: 0 }} key={name} value={name}>
                <Checkbox
                  checked={checked}
                  onClick={() =>
                    handleCheckboxChange({
                      name: name,
                      checked: checked,
                      docCount: docCount,
                    })
                  }
                  onChange={() => setIsFiltering(true)}
                />
                <ListItemText primary={`${name} (${docCount})`} />
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>
              <ListItemText primary="No options available" />
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
};
export default SelectMultipleCheckboxes;
